<template>
    <div class="bonusomat-spin-footer">
        <div class="bonusomat-spin-footer__remain">
            <DsIcon class="bonusomat-spin-footer__remain-icon" name="b-mat" :width="24" />
            <span class="bonusomat-spin-footer__remain-text" v-html="remainText"></span>
        </div>
        <DsButton
            class="bonusomat-spin-footer__table"
            type="text"
            size="sm"
            icon-right="money-bag-coins"
            @click="showWinnerTableInternal"
            >Tabulka výher</DsButton
        >
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";

const props = defineProps<{
    remainingSpinsCount: number;
}>();
const emit = defineEmits(["showWinnerTable"]);

const showWinnerTableInternal = () => emit("showWinnerTable");

const remainText = computed(() => {
    if (props.remainingSpinsCount > 0) {
        return ` K dispozici ${props.remainingSpinsCount}&nbsp;zatočení`;
    }
    return "Zatočení není k dispozici";
});
</script>
